//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Bromage',

  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/Chart_Bromage.vue